// import React, { useState, useEffect } from 'react';
// import { useNavigate, Outlet } from 'react-router-dom';
// import { getUsers, updateUser, deleteUser } from '../services/api';

// const ManageUsers = () => {
//   const [users, setUsers] = useState([]);
//   const [error, setError] = useState(null);
//   const [editingUserId, setEditingUserId] = useState(null);
//   const [editFormData, setEditFormData] = useState({});
//   const navigate = useNavigate();
//   const role = localStorage.getItem('role');

//   useEffect(() => {
//     if (role !== 'super_admin') {
//       navigate('/dashboard');
//       return;
//     }

//     fetchUsers();
//   }, [navigate, role]);

//   const fetchUsers = async () => {
//     try {
//       const res = await getUsers();
//       if (res.data.success) {
//         setUsers(res.data.data);
//       } else {
//         setError(res.data.error || 'Failed to fetch users');
//       }
//       console.log('API Response:', res.data); // Debug log
//     } catch (err) {
//       console.error('Error fetching users:', err);
//       setError(err.response?.data?.error || 'Failed to fetch users');
//     }
//   };

//   const handleEdit = (user) => {
//     setEditingUserId(user.id);
//     setEditFormData({ ...user, password: '' });
//   };

//   const handleSave = async (userId) => {
//     const dataToSubmit = {};
//     const originalUser = users.find(u => u.id === userId);

//     if (editFormData.username && editFormData.username !== originalUser.username) dataToSubmit.username = editFormData.username;
//     if (editFormData.email && editFormData.email !== originalUser.email) dataToSubmit.email = editFormData.email;
//     if (editFormData.password) dataToSubmit.password = editFormData.password;
//     if (role === 'super_admin' && editFormData.role && editFormData.role !== originalUser.role) dataToSubmit.role = editFormData.role;
//     if (editFormData.employee_name && editFormData.employee_name !== originalUser.employee_name) dataToSubmit.employee_name = editFormData.employee_name;
//     if (editFormData.employee_code && editFormData.employee_code !== originalUser.employee_code) dataToSubmit.employee_code = editFormData.employee_code;

//     if (Object.keys(dataToSubmit).length > 0) {
//       try {
//         const response = await updateUser(userId, dataToSubmit);
//         if (response.data.success) {
//           setUsers(users.map(user => user.id === userId ? { ...user, ...editFormData } : user));
//           setEditingUserId(null);
//         } else {
//           setError(response.data.error || 'Failed to update user');
//         }
//       } catch (err) {
//         console.error('Error updating user:', err.response?.data || err.message);
//         setError(err.response?.data?.error || 'Failed to update user');
//       }
//     } else {
//       setEditingUserId(null);
//     }
//   };

//   const handleCancel = () => {
//     setEditingUserId(null);
//     setEditFormData({});
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setEditFormData({ ...editFormData, [name]: value });
//   };

//   const handleDelete = async (userId) => {
//     if (window.confirm('Are you sure you want to delete this user?')) {
//       try {
//         await deleteUser(userId);
//         setUsers(users.filter(user => user.id !== userId));
//       } catch (err) {
//         console.error('Error deleting user:', err);
//         setError(err.response?.data?.error || 'Failed to delete user');
//       }
//     }
//   };

//   if (role !== 'super_admin') return null;

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen">
//       <h2 className="text-3xl font-bold text-gray-900 mb-6">Manage Users</h2>
//       {error && <p className="text-red-600 mb-4">{error}</p>}
//       {users.length > 0 ? (
//         <div className="overflow-x-auto bg-white shadow-lg rounded-lg">
//           <table className="min-w-full divide-y divide-gray-200" style={{ tableLayout: 'fixed' }}>
//             <thead className="bg-indigo-600">
//               <tr>
//                 <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '60px' }}>ID</th>
//                 <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '140px' }}>Username</th>
//                 <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '180px' }}>Email</th>
//                 <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '140px' }}>Role</th>
//                 <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '160px' }}>Employee Name</th>
//                 <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '120px' }}>Employee Code</th>
//                 <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '200px' }}>Actions</th>
//               </tr>
//             </thead>
//             <tbody className="bg-white divide-y divide-gray-200">
//               {users.map(user => (
//                 <tr key={user.id} className="hover:bg-gray-50 transition-colors">
//                   <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900">{user.id}</td>
//                   {editingUserId === user.id ? (
//                     <>
//                       <td className="px-4 py-2 whitespace-nowrap">
//                         <input
//                           type="text"
//                           name="username"
//                           value={editFormData.username || ''}
//                           onChange={handleChange}
//                           className="w-full p-1 border border-gray-300 rounded-md"
//                         />
//                       </td>
//                       <td className="px-4 py-2 whitespace-nowrap">
//                         <input
//                           type="email"
//                           name="email"
//                           value={editFormData.email || ''}
//                           onChange={handleChange}
//                           className="w-full p-1 border border-gray-300 rounded-md"
//                         />
//                       </td>
//                       <td className="px-4 py-2 whitespace-nowrap">
//                         {role === 'super_admin' && (
//                           <select
//                             name="role"
//                             value={editFormData.role || ''}
//                             onChange={handleChange}
//                             className="w-full p-1 border border-gray-300 rounded-md"
//                           >
//                             <option value="employee">Employee</option>
//                             <option value="manager">Manager</option>
//                             <option value="functional_admin">Functional Admin</option>
//                             <option value="super_admin">Super Admin</option>
//                           </select>
//                         )}
//                       </td>
//                       <td className="px-4 py-2 whitespace-nowrap">
//                         <input
//                           type="text"
//                           name="employee_name"
//                           value={editFormData.employee_name || ''}
//                           onChange={handleChange}
//                           className="w-full p-1 border border-gray-300 rounded-md"
//                         />
//                       </td>
//                       <td className="px-4 py-2 whitespace-nowrap">
//                         <input
//                           type="text"
//                           name="employee_code"
//                           value={editFormData.employee_code || ''}
//                           onChange={handleChange}
//                           className="w-full p-1 border border-gray-300 rounded-md"
//                         />
//                       </td>
//                       <td className="px-4 py-2 whitespace-nowrap flex space-x-2">
//                         <button
//                           className="bg-green-500 text-white px-2 py-1 rounded-md hover:bg-green-600 transition-colors"
//                           onClick={() => handleSave(user.id)}
//                         >
//                           Save
//                         </button>
//                         <button
//                           className="bg-gray-500 text-white px-2 py-1 rounded-md hover:bg-gray-600 transition-colors"
//                           onClick={handleCancel}
//                         >
//                           Cancel
//                         </button>
//                       </td>
//                     </>
//                   ) : (
//                     <>
//                       <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900">{user.username}</td>
//                       <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900">{user.email || 'N/A'}</td>
//                       <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900">{user.role}</td>
//                       <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900">{user.employee_name || 'N/A'}</td>
//                       <td className="px-4 py-2 whitespace-nowrap text-sm text-gray-900">{user.employee_code || 'N/A'}</td>
//                       <td className="px-4 py-2 whitespace-nowrap flex space-x-2">
//                         <button
//                           className="bg-yellow-500 text-white px-2 py-1 rounded-md hover:bg-yellow-600 transition-colors"
//                           onClick={() => handleEdit(user)}
//                         >
//                           Update
//                         </button>
//                         <button
//                           className="bg-red-500 text-white px-2 py-1 rounded-md hover:bg-red-600 transition-colors"
//                           onClick={() => handleDelete(user.id)}
//                         >
//                           Delete
//                         </button>
//                       </td>
//                     </>
//                   )}
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       ) : (
//         <p className="text-gray-600 mt-4">No users found.</p>
//       )}
//       <button
//         className="mt-6 bg-indigo-500 text-white px-6 py-3 rounded-md hover:bg-indigo-600 transition-colors"
//         onClick={() => navigate('/dashboard/users/create')}
//       >
//         Create New User
//       </button>
//       <Outlet />
//     </div>
//   );
// };

// export default ManageUsers;

import React, { useState, useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom';
import { getUsers, updateUser, deleteUser } from '../services/api';

const ManageUsers = () => {
  const [users, setUsers] = useState([]);
  const [error, setError] = useState(null);
  const [editingUserId, setEditingUserId] = useState(null);
  const [editFormData, setEditFormData] = useState({});
  const navigate = useNavigate();
  const role = localStorage.getItem('role');

  useEffect(() => {
    if (role !== 'super_admin') { navigate('/dashboard'); return; }
    fetchUsers();
  }, [navigate, role]);

  const fetchUsers = async () => {
    try {
      const res = await getUsers();
      if (res.data.success) {
        setUsers(res.data.data);
      } else {
        setError(res.data.error || 'Failed to fetch users');
      }
    } catch (err) {
      console.error('Error fetching users:', err);
      setError(err.response?.data?.error || 'Failed to fetch users');
    }
  };

  const handleEdit = (user) => { setEditingUserId(user.id); setEditFormData({ ...user, password: '' }); };
  const handleCancel = () => { setEditingUserId(null); setEditFormData({}); };
  const handleChange = (e) => { const { name, value } = e.target; setEditFormData({ ...editFormData, [name]: value }); };

  const handleSave = async (userId) => {
    const dataToSubmit = {};
    const originalUser = users.find(u => u.id === userId);
    if (editFormData.username && editFormData.username !== originalUser.username) dataToSubmit.username = editFormData.username;
    if (editFormData.email && editFormData.email !== originalUser.email) dataToSubmit.email = editFormData.email;
    if (editFormData.password) dataToSubmit.password = editFormData.password;
    if (role === 'super_admin' && editFormData.role && editFormData.role !== originalUser.role) dataToSubmit.role = editFormData.role;
    if (editFormData.employee_name && editFormData.employee_name !== originalUser.employee_name) dataToSubmit.employee_name = editFormData.employee_name;
    if (editFormData.employee_code && editFormData.employee_code !== originalUser.employee_code) dataToSubmit.employee_code = editFormData.employee_code;
    if (Object.keys(dataToSubmit).length > 0) {
      try {
        const response = await updateUser(userId, dataToSubmit);
        if (response.data.success) {
          setUsers(users.map(user => user.id === userId ? { ...user, ...editFormData } : user));
          setEditingUserId(null);
        } else { setError(response.data.error || 'Failed to update user'); }
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to update user');
      }
    } else { setEditingUserId(null); }
  };

  const handleDelete = async (userId) => {
    if (window.confirm('Are you sure you want to delete this user?')) {
      try {
        await deleteUser(userId);
        setUsers(users.filter(user => user.id !== userId));
      } catch (err) {
        setError(err.response?.data?.error || 'Failed to delete user');
      }
    }
  };

  if (role !== 'super_admin') return null;

  return (
    <div className="p-3 sm:p-6 bg-gray-50 min-h-screen">
      <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4 sm:mb-6">Manage Users</h2>
      {error && <p className="text-red-600 mb-4 text-sm">{error}</p>}

      {users.length > 0 ? (
        <>
          {/* Mobile Cards */}
          <div className="lg:hidden space-y-4">
            {users.map(user => (
              <div key={user.id} className="bg-white rounded-lg shadow p-4">
                {editingUserId === user.id ? (
                  <div className="space-y-3">
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="text-xs text-gray-500 mb-1 block">Username</label>
                        <input type="text" name="username" value={editFormData.username || ''} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded text-sm" />
                      </div>
                      <div>
                        <label className="text-xs text-gray-500 mb-1 block">Email</label>
                        <input type="email" name="email" value={editFormData.email || ''} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded text-sm" />
                      </div>
                      <div>
                        <label className="text-xs text-gray-500 mb-1 block">Role</label>
                        <select name="role" value={editFormData.role || ''} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded text-sm">
                          <option value="employee">Employee</option>
                          <option value="manager">Manager</option>
                          <option value="functional_admin">Functional Admin</option>
                          <option value="super_admin">Super Admin</option>
                        </select>
                      </div>
                      <div>
                        <label className="text-xs text-gray-500 mb-1 block">Employee Name</label>
                        <input type="text" name="employee_name" value={editFormData.employee_name || ''} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded text-sm" />
                      </div>
                      <div>
                        <label className="text-xs text-gray-500 mb-1 block">Employee Code</label>
                        <input type="text" name="employee_code" value={editFormData.employee_code || ''} onChange={handleChange} className="w-full p-2 border border-gray-300 rounded text-sm" />
                      </div>
                    </div>
                    <div className="flex gap-2 pt-2">
                      <button className="bg-green-500 text-white px-4 py-2 rounded text-sm hover:bg-green-600" onClick={() => handleSave(user.id)}>Save</button>
                      <button className="bg-gray-500 text-white px-4 py-2 rounded text-sm hover:bg-gray-600" onClick={handleCancel}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="flex justify-between items-start mb-2">
                      <div>
                        <p className="font-semibold text-gray-900">{user.username}</p>
                        <p className="text-xs text-gray-500">{user.email || 'N/A'}</p>
                      </div>
                      <span className="bg-indigo-100 text-indigo-700 text-xs px-2 py-1 rounded-full">{user.role}</span>
                    </div>
                    <div className="text-sm text-gray-600 mb-3">
                      <span className="mr-4">👤 {user.employee_name || 'N/A'}</span>
                      <span>🆔 {user.employee_code || 'N/A'}</span>
                    </div>
                    <div className="flex gap-2">
                      <button className="bg-yellow-500 text-white px-3 py-1.5 rounded text-sm hover:bg-yellow-600" onClick={() => handleEdit(user)}>Update</button>
                      <button className="bg-red-500 text-white px-3 py-1.5 rounded text-sm hover:bg-red-600" onClick={() => handleDelete(user.id)}>Delete</button>
                    </div>
                  </>
                )}
              </div>
            ))}
          </div>

          {/* Desktop Table */}
          <div className="hidden lg:block overflow-x-auto bg-white shadow-lg rounded-lg">
            <table className="min-w-full divide-y divide-gray-200" style={{ tableLayout: 'fixed' }}>
              <thead className="bg-indigo-600">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '60px' }}>ID</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '140px' }}>Username</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '180px' }}>Email</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '140px' }}>Role</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '160px' }}>Employee Name</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '120px' }}>Employee Code</th>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-white" style={{ width: '200px' }}>Actions</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {users.map(user => (
                  <tr key={user.id} className="hover:bg-gray-50 transition-colors">
                    <td className="px-4 py-2 text-sm text-gray-900">{user.id}</td>
                    {editingUserId === user.id ? (
                      <>
                        <td className="px-4 py-2"><input type="text" name="username" value={editFormData.username || ''} onChange={handleChange} className="w-full p-1 border border-gray-300 rounded" /></td>
                        <td className="px-4 py-2"><input type="email" name="email" value={editFormData.email || ''} onChange={handleChange} className="w-full p-1 border border-gray-300 rounded" /></td>
                        <td className="px-4 py-2">
                          <select name="role" value={editFormData.role || ''} onChange={handleChange} className="w-full p-1 border border-gray-300 rounded">
                            <option value="employee">Employee</option>
                            <option value="manager">Manager</option>
                            <option value="functional_admin">Functional Admin</option>
                            <option value="super_admin">Super Admin</option>
                          </select>
                        </td>
                        <td className="px-4 py-2"><input type="text" name="employee_name" value={editFormData.employee_name || ''} onChange={handleChange} className="w-full p-1 border border-gray-300 rounded" /></td>
                        <td className="px-4 py-2"><input type="text" name="employee_code" value={editFormData.employee_code || ''} onChange={handleChange} className="w-full p-1 border border-gray-300 rounded" /></td>
                        <td className="px-4 py-2 flex space-x-2">
                          <button className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600" onClick={() => handleSave(user.id)}>Save</button>
                          <button className="bg-gray-500 text-white px-2 py-1 rounded hover:bg-gray-600" onClick={handleCancel}>Cancel</button>
                        </td>
                      </>
                    ) : (
                      <>
                        <td className="px-4 py-2 text-sm text-gray-900">{user.username}</td>
                        <td className="px-4 py-2 text-sm text-gray-900">{user.email || 'N/A'}</td>
                        <td className="px-4 py-2 text-sm text-gray-900">{user.role}</td>
                        <td className="px-4 py-2 text-sm text-gray-900">{user.employee_name || 'N/A'}</td>
                        <td className="px-4 py-2 text-sm text-gray-900">{user.employee_code || 'N/A'}</td>
                        <td className="px-4 py-2 flex space-x-2">
                          <button className="bg-yellow-500 text-white px-2 py-1 rounded hover:bg-yellow-600" onClick={() => handleEdit(user)}>Update</button>
                          <button className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600" onClick={() => handleDelete(user.id)}>Delete</button>
                        </td>
                      </>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      ) : (
        <p className="text-gray-600 mt-4">No users found.</p>
      )}

      <button
        className="mt-6 bg-indigo-500 text-white px-5 py-2.5 sm:px-6 sm:py-3 rounded-md hover:bg-indigo-600 transition-colors text-sm sm:text-base"
        onClick={() => navigate('/dashboard/users/create')}
      >
        + Create New User
      </button>
      <Outlet />
    </div>
  );
};

export default ManageUsers;